const NAVIGATION_SHORTCUT_TARGETS = [
  { label: "Worship", to: "/worship" },
  { label: "Bible", to: "/bibleis" },
  { label: "Present", to: "/present", preferredKey: "p" },
  { label: "Session", to: "/session", preferredKey: "s" },
  { label: "Songs", to: "/songs", preferredKey: "g" },
  { label: "Videos", to: "/video", preferredKey: "v" },
  { label: "Karaoke", to: "/karaoke", preferredKey: "k" },
  { label: "Music", to: "/music", preferredKey: "m" },
  { label: "GCC TV", to: "/live", preferredKey: "t" },
  { label: "Join", to: "https://www.youtube.com/@gcc-worship?sub_confirmation=1", external: true, preferredKey: "j" },
  { label: "Events", to: "/events", preferredKey: "e" },
  { label: "Messages", to: "/messages", preferredKey: "i" },
  { label: "Help", to: "/help", preferredKey: "h" },
];

const isLetter = (char) => /[a-z]/.test(char);

const buildNavigationShortcutMap = (targets) => {
  const assigned = {};
  const usedKeys = new Set();

  const assignKey = (target, key) => {
    const normalized = key?.toLowerCase();
    if (!isLetter(normalized) || usedKeys.has(normalized)) return false;
    usedKeys.add(normalized);
    assigned[normalized] = { ...target, shortcut: normalized };
    return true;
  };

  targets.forEach((target) => {
    if (target.preferredKey && assignKey(target, target.preferredKey)) {
      return;
    }

    const letters = (target.label || "")
      .toLowerCase()
      .split("")
      .filter(isLetter);

    if (letters.some((letter) => assignKey(target, letter))) {
      return;
    }

    for (let charCode = 97; charCode <= 122; charCode += 1) {
      const letter = String.fromCharCode(charCode);
      if (assignKey(target, letter)) {
        break;
      }
    }
  });

  return assigned;
};

const SHORTCUT_MAP = buildNavigationShortcutMap(NAVIGATION_SHORTCUT_TARGETS);

const SHORTCUT_LEGEND = NAVIGATION_SHORTCUT_TARGETS.map((target) => {
  const entry = Object.entries(SHORTCUT_MAP).find(
    ([, value]) => value.label === target.label && value.to === target.to && value.external === target.external
  );
  return {
    label: target.label,
    key: entry ? entry[0].toUpperCase() : "",
    target: target.to,
    external: target.external || false,
  };
});

export { NAVIGATION_SHORTCUT_TARGETS, buildNavigationShortcutMap, SHORTCUT_MAP, SHORTCUT_LEGEND };
